import { MRT_Row, MRT_TableInstance } from "material-react-table";
import { IconButton, Tooltip, Typography } from "@mui/material";
import { Edit } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import type { FleetEventRow } from "../FleetManagementEventDetailTable.component";
import { isEventEditable } from "../functions/isEventEditable.function";

type Props = {
  row: MRT_Row<FleetEventRow>;
  table: MRT_TableInstance<FleetEventRow>;
  timezone: string;
};

export function FleetManagementEventDetailTableRowActions({
  row,
  table,
  timezone
}: Readonly<Props>) {
  const { t } = useTranslation();

  if (row.original.isPending || !isEventEditable(row, timezone)) {
    return null;
  }

  return (
    <Tooltip title={<Typography>{t("Edit")}</Typography>} aria-label="Edit">
      <IconButton
        data-testid="fleet-event-detail-edit-row-btn"
        size="small"
        onClick={() => table.setEditingRow(row)}
      >
        <Edit />
      </IconButton>
    </Tooltip>
  );
}
